import { FC } from 'react';
import { SurveyPendingSubmissionsTraining } from 'containers/surveys';
import { SurveyResultsLayout } from 'pages/atoms';

const SurveyResultsPendingSubmissionsTrainingPage: FC = () => {
  return (
    <SurveyResultsLayout>
      <SurveyPendingSubmissionsTraining />
    </SurveyResultsLayout>
  );
};

export default SurveyResultsPendingSubmissionsTrainingPage;
